/* eslint-disable @typescript-eslint/camelcase */
import { BaseEvent } from './BaseEvent';
const eventList = {
    'player.start.live': 201,
    'player.play.live': 202,
    'player.stop': 203,
    'player.complete.vod': 204,
    'player.progress.live': 206,
    'player.chromecast.on': 207,
    'player.chromecast.off': 208,
    'player.fullscreen.enabled': 209,
    'player.fullscreen.disabled': 210,
    'player.volume.set': 211,
    'player.volume.mute': 212,
    'player.adbegin.live': 213,
    'player.adcomplete.live': 215,
    'player.load.live': 216,
    'player.play.vod': 217,
    'player.progress.vod': 218,
    'player.load.vod': 219,
    'player.adbegin.vod': 220,
    'player.adcomplete.vod': 221,
    'player.pause': 225,
    'player.resume': 226,
    'player.start.vod': 227,
    'player.ad.staticimp': 250,
};
export class PlayerEvent extends BaseEvent {
    constructor(eventName) {
        super();
        this.ad_creative_id = '';
        this.ad_lineitem_id = 0;
        this.player_captions = '';
        this.player_connection_speed = '';
        this.player_content_access = '';
        this.player_content_playstate = '';
        this.player_fullscreen = false;
        this.player_media_id = '';
        this.player_media_type = '';
        this.player_video_session_id = '';
        this.player_volume = '';
        this.stream_url = '';
        this.player_screen_width = 0;
        this.player_screen_height = 0;
        this.player_stream_quality = '';
        this.player_channel_name = '';
        this.player_from_position = 0;
        this.player_to_position = 0;
        this.metadata_content_length = 0;
        if (eventList[eventName] === undefined) {
            throw new Error(`${eventName} event is not supported by this library.`);
        }
        this.event_group = 'Player';
        this.event_id = eventList[eventName];
        this.event_name = eventName;
        // Not very multi device friendly however - an idea?
        // player_screen_width = this.device_screen_width;
        // player_screen_height = this.device_screen_height;
    }
    progressEvent(from, to) {
        this.player_from_position = Number(from) >= 0 ? Number(from) : 0.0;
        this.player_to_position = Number(to) >= 0 ? Number(to) : 0.0;
    }
}
//# sourceMappingURL=PlayerEvent.js.map